import { render } from "./IconArrowBack.vue?vue&type=template&id=1324c084"
import script from "./IconArrowBack.vue?vue&type=script&lang=js"
export * from "./IconArrowBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__